import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import classes from './svg-styles.module.sass'

const ArrowRight = ({ color, className }) => (
  <svg color={color} className={cn(classes.svg, className)} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path color="currentColor" d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-3 18v-12l9 6-9 6z" />
  </svg>
)

ArrowRight.defaultProps = {
  color: '#000',
  className: '',
}

ArrowRight.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string,
}

export default ArrowRight
